const AVATAR_BASE_URL = "https://static-assets.amberstudent.com/images/Avatars";
const AVATAR_COUNT = 18;

const getAvatarByIndex = (index: number): string =>
  `${AVATAR_BASE_URL}/avatar-${(index % AVATAR_COUNT) + 1}.png`;

/**
 * Returns a deterministic avatar based on the reviewer's name or index.
 * Uses a simple hash of the name to pick consistently (same name = same avatar).
 * Falls back to index-based cycling if name is empty.
 */
// eslint-disable-next-line import/prefer-default-export
export function getRandomAvatar(name: string, index: number): string {
  if (name) {
    // Simple hash from name characters
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) {
      hash = (hash * 31 + name.charCodeAt(i)) % AVATAR_COUNT;
    }
    return getAvatarByIndex(Math.abs(hash));
  }
  return getAvatarByIndex(index);
}
